import { useCurrentSpace } from 'src/hooks/space';
import { useTocIds } from '../toc/use-toc-id';
import { useIsGuest } from 'src/hooks/share/use-permission-utils';
import { useCurrentUser } from 'src/hooks/user';
import { getState } from 'src/redux/store';
import { BlockType } from '@next-space/fe-api-idl';
import { usePersonalWikiId } from './use-personal-wiki-id';
import { useMemo } from 'react';
import { useObservableStore } from 'src/services/rxjs-redux/use-obs-store';

export const useWikiIds = () => {
  const personalWikiId = usePersonalWikiId();
  const currentSpace = useCurrentSpace();
  const isGuest = useIsGuest();
  const currentUser = useCurrentUser();
  const tocIds = useTocIds(currentSpace.uuid, currentUser.uuid, isGuest, true);
  const wikiIds = useMemo(() => {
    return tocIds.person.filter((id) => {
      return personalWikiId !== id && getState().blocks[id]?.type === BlockType.WIKI;
    });
  }, [personalWikiId, tocIds.person]);
  return wikiIds;
};

export const useWikiSubNodes = (blockId: string) => {
  return useObservableStore(
    (state) => {
      const block = state.blocks[blockId];
      return block?.subNodes.filter((id) => {
        const b = state.blocks[id];
        return b?.type === BlockType.FILE || b?.type === BlockType.REFERENCE;
      });
    },
    [blockId]
  );
};
